import { Badge, Table } from "react-bootstrap";

import { CommonMessage } from "../types";

// A one-line summary of a seed/input message. Deliberately plain (F1 is
// read-only): the component-lens editors arriving in F4 replace this view
// with the shared state visualizations.
const summarizeMessage = (message: CommonMessage): string => {
  if ("content" in message && typeof message.content === "string") {
    return message.content;
  }
  if ("key" in message && typeof message.key === "string") {
    const value = "value" in message ? message.value : undefined;
    return `${message.key} = ${
      typeof value === "string" ? value : JSON.stringify(value)
    }`;
  }
  const rest: Record<string, unknown> = { ...message };
  delete rest.message_type;
  return JSON.stringify(rest);
};

/**
 * Plain read-only listing of one component's seed messages. The seed carries
 * no channels: the run targets each component's messages by its id.
 */
const PlaygroundMessageList = ({
  messages,
}: {
  messages: Array<CommonMessage>;
}) => {
  if (messages.length === 0) {
    return <p className="text-body-secondary mb-0">No messages.</p>;
  }

  return (
    <Table size="sm" className="mb-0">
      <tbody>
        {messages.map((message, index) => (
          <tr key={index} data-testid="playground-message-row">
            <td className="text-nowrap">
              <Badge bg="secondary">{message.message_type}</Badge>
            </td>
            <td>
              <span className="font-monospace pre-wrap">
                {summarizeMessage(message)}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default PlaygroundMessageList;
